<template>
  <div class="open-app">
    <div class="open">
      <p class="btn" id="btn">打开APP</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.init()
  },
  methods: {
    init() {
      var data = OpenInstall.parseUrlParams() ///openinstall.js中提供的工具函数，解析url中的所有查询参数
      new OpenInstall(
        {
          appKey: 'x29emf',
          /*OpenInstall初始化完成的回调函数，可选*/
          onready: function() {
            /*在app已安装的情况尝试拉起app*/
            this.schemeWakeup()

            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            const button = document.getElementById('btn')
            const _this = this
            button.onclick = function() {
              _this.wakeupOrInstall()
              return false
            }
          },
        },
        data,
      )
    },
  },
}
</script>

<style lang="less" scoped>
.open-app {
  width: 100px;
  position: fixed;
  bottom: 20%;
  right: 0;
  padding: 8px;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  .open {
    .btn {
      padding: 6px 10px;
      color: #fff;
      font-size: 14px;
      border-radius: 40px;
      background-color: #f17c25;
    }
  }
}
</style>
